import { bktachoProfile } from 'app/profiles/bktacho.profile';
import { tachosafeLocalhostProfile } from 'app/profiles/localhost.profile';
import { tachosafeStagingProfile } from 'app/profiles/staging.profile';
import { tachosafeProfile } from 'app/profiles/tachosafe.profile';
import { tachosafeTrProfile } from 'app/profiles/tachosafeTR';
import { teksonfleetProfile } from 'app/profiles/teksonfleet.profile';
import { trackgpsProfile } from 'app/profiles/trackgps.profile';
import { environment } from 'environments/environment';

type Global = typeof globalThis & { selectedProfile: Profile };

export const getProfile = (): Profile => {
    return (globalThis as Global).selectedProfile;
}

export type Profile = {
    domains: string[];
    key: string;
    theme: string;
    apiUrl: string | ((domain: string) => string);
    billingApiUrl: string | ((domain: string) => string);
    chartApiUrl: string | ((domain: string) => string);
    i18nUrl: string;
    i18nKey: string;
    disabledFeatures: string[];
    topBarButtons: TopBarButtons;
    language: {
        fallback: string;
        default: string;
    };
    showAds: boolean;
    websiteTitle: string;
    staticFiles: {
        logoColor: string;
        logoBlackAndWhite: string;
        favicon: string;
        backgroundImage: string;
    };
    footerLinks?: {
        name: string;
        url: string;
    }[],
    documentLinks: {
        termsOfService: string;
        cookieNotice: string;
        privacyPolicy: string;
    }
    noDriverVehicleBanner: 'normal' | 'noAds' | 'none';
    disabledReports: string[];
    forceShowScheduledReports: boolean;
    bffLogin?: {
        url: string;
        userUrl: string;
        changePasswordUrl?: string;
    };
    ssoOverrides?: {
        apiUrl: string | ((domain: string) => string);
        billingApiUrl: string | ((domain: string) => string);
        chartApiUrl: string | ((domain: string) => string);
    };
}

export type TopBarButtons = {
    more: boolean;
    help: boolean;
    phone: boolean;
    rduAdmin: boolean;
    rduManager: boolean;
    t2sUpdater: boolean;
    tachosafeSite: boolean;
    changesInStructure: boolean;
}

export const DEFAULT_TOP_BAR_BUTTONS: TopBarButtons = {
    more: true,
    help: true,
    phone: true,
    rduAdmin: true,
    rduManager: true,
    t2sUpdater: true,
    tachosafeSite: true,
    changesInStructure: true,
};

const profiles: Profile[] = [
    teksonfleetProfile,
    bktachoProfile,
    trackgpsProfile,
    tachosafeTrProfile,
    tachosafeProfile,
    tachosafeStagingProfile,
    tachosafeLocalhostProfile,
]
const defaultProfile: Profile = tachosafeProfile;
const domain = window.location.hostname;


const selectedProfile = profiles.find(profile => profile.domains.includes(domain)) || defaultProfile;
// const selectedProfile = trackgpsProfile;
// selectedProfile.apiUrl = tachosafeLocalhostProfile.apiUrl;
// const selectedProfile = teksonfleetProfile;
(globalThis as Global).selectedProfile = selectedProfile;
console.log('Selected profile:', selectedProfile.key);
document.getElementById('mainBody').classList.add(`${selectedProfile.theme}-theme`);




// let curr_domain= window.location.hostname;
// let api_url= '';
// let report_url = '';

// switch (curr_domain) {
//     case 'localhost':
//         api_url = 'http://localhost:4200/TachoSafe/';
//         break;
//     case 'tachosafe.local':
//         api_url = 'http://tachosafe.local:8081/TachoSafe/';
//         break;
//     case 'trackgps-staging.tacho4safe.com':
//         api_url = 'https://api-staging.tacho4safe.com/TachoSafe/';
//         report_url = 'https://rszoft-report-staging.tacho4safe.com/TachoSafe/';
//         break;
//     // case 'tachoanalitics.trackgps.ro':
//     //     api_url = 'https://api-tachoanalitics.trackgps.ro/TachoSafe/';
//     //     report_url = 'https://rszoft-report-tachoanalitics.trackgps.ro/TachoSafe/';
//     //     break;
//     default:
//         if(window.location.hostname.split('.').length <= 2){
//             api_url = `https://api.${window.location.hostname}/TachoSafe/`;
//             report_url = `https://rszoft-report.${window.location.hostname}/charts-generator-api/v0/`;
//         }else{
//             api_url = `https://api-${window.location.hostname}/TachoSafe/`;
//             report_url = `https://rszoft-report-${window.location.hostname}/charts-generator-api/v0/`;
//         }
//         break;
// }

function resolveUrl(url: string | ((domain: string) => string), d: string): string {
    return url instanceof Function ? url(d) : url;
}

export let API_URL = resolveUrl(selectedProfile.apiUrl, domain);
export let CHART_API_URL = resolveUrl(selectedProfile.chartApiUrl, domain);

export type LoginMode = 'sso' | 'credentials';

export function setLoginMode(mode: LoginMode) {
    localStorage.setItem('loginMode', mode);
    const profile = getProfile();
    if (mode === 'sso' && profile.ssoOverrides) {
        API_URL = resolveUrl(profile.ssoOverrides.apiUrl, domain);
        CHART_API_URL = resolveUrl(profile.ssoOverrides.chartApiUrl, domain);
        profile.billingApiUrl = profile.ssoOverrides.billingApiUrl;
    } else {
        API_URL = resolveUrl(profile.apiUrl, domain);
        CHART_API_URL = resolveUrl(profile.chartApiUrl, domain);
    }
}

export function clearLoginMode() {
    localStorage.removeItem('loginMode');
}

// Restore login mode from previous session
const storedLoginMode = localStorage.getItem('loginMode') as LoginMode | null;
if (storedLoginMode === 'sso') {
    setLoginMode('sso');
}

export const DEVICE_QR_URL = `${window.location.origin}/app`;
export const CURRENT_APPLICATION_VERSION = environment.appVersion;
export const COLOR_CHART_GREY = '#777777';
export const COLOR_DRIVE = '#FF0000';
export const COLOR_REST = '#00FF00';
export const COLOR_AVAILABLE = '#F7931D';
export const COLOR_WORK = '#0000FF';
export const COLOR_WORKING_TIME = '#d38fc5';
export const COLOR_CREW_DRIVING = '#c2d8f2';
export const COLOR_INFRINGMENT = '#BC1E14';

export const LANGUAGES = [
    'HU', 'EN', 'RO', 'DE', 'NL', 'FR', 'DA', 'ES', 'SL', 'IT', 'SK', 'BG', 'CS', 'TR'
]
export const TIMEZONES = [
    // 'UTC', 'CET', 'America/Argentina/Cordoba', 'Pacific/Pago_Pago', 'Asia/Ulan_Bator'
    'UTC', 'WET', 'CET', 'EET'
]

export const NUMBER_OF_CHART_TO_OPEN_DIALOG = 14;
export const NUMBER_OF_CHART_TO_PRINT_DIALOG = 85;
// 2G terminal replacement campaign: popup and top-bar warning icon
export const DEVICE_REPLACEMENT_WARNING_ENABLED = false;
export const PROFILE = environment.PROFILE;

export const I18N_URL = environment.I18N_URL;
export const I18N_KEY = environment.I18N_KEY;
export const THEME_PROFILE = selectedProfile;


// export const TRACKING_ID = environment.TRACKING_ID;

